import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useUserAuth } from "../../context/UserAuthContext";
import { MdDelete, MdEdit } from "react-icons/md";
import axios from "axios";

const InvoiceItem = () => {
  const { user, token } = useUserAuth();
  const user_id = user?.uid;

  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [invoiceItem, setInvoiceItem] = useState([]);
  const [editingItemId, setEditingItemId] = useState(null);

  const [data, setData] = useState({
    title: "",
    description: "",
    price: "",
  });

  useEffect(() => {
    if (!user_id) return;

    const fetchInvoiceItems = async () => {
      try {
        const response = await axios.get(`${base_url}/api/v1/invoice-items/${user_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
        setInvoiceItem(response.data.data);
      } catch (error) {
        console.error("Error fetching invoice items:", error);
      }
    };

    fetchInvoiceItems();
  }, [user_id, token]);

  const formHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const btnHandler = async (e) => {
    e.preventDefault();
    const { title, description, price } = data;

    if (!title || !description || !price) {
      alert("All fields are required.");
      return;
    }
    try {
      if (editingItemId) {
        // Update existing item
        const updatedData = { title, description, price };
        await axios.put(`${base_url}/api/v1/invoice-items/${editingItemId}`,
          updatedData, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
        setInvoiceItem((prevItems) =>
          prevItems.map((item) =>
            item.id === editingItemId ? { ...item, ...updatedData } : item
          )
        );
        toast.success("Item updated successfully");
      } else {
        // Add new item
        const newItem = { user_id, title, description, price };
        const response = await axios.post(`${base_url}/api/v1/invoice-items`,
          newItem, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
        );
        setInvoiceItem((prevItems = []) => [...prevItems, response.data.data]);
        toast.success("Item added successfully");
      }

      setData({ title: "", description: "", price: "" });
      setEditingItemId(null);
    } catch (error) {
      console.error("Error saving item:", error);
      toast.error("Error saving item.");
    }
  };

  const deleteItem = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${base_url}/api/v1/invoice-items/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setInvoiceItem((prevItems) => prevItems.filter((item) => item.id !== id));
      toast.success("Item deleted successfully");
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Error deleting item.");
    }
  };

  const startEditing = (item) => {
    setEditingItemId(item.id);
    setData({
      title: item.title,
      description: item.description,
      price: item.price,
    });
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                Manage Your Items
              </div>
              <div className="card-body">
                <form onSubmit={btnHandler}>
                  <div className="row">
                    <div className="form-group col-md-4">
                      <label htmlFor="title">Title</label>
                      <input
                        type="text"
                        name="title"
                        placeholder="Enter Title"
                        className="form-control"
                        id="title"
                        value={data.title}
                        onChange={formHandler}
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label htmlFor="description">Description</label>
                      <input
                        type="text"
                        name="description"
                        placeholder="Enter Description"
                        className="form-control"
                        id="description"
                        value={data.description}
                        onChange={formHandler}
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label htmlFor="price">Price</label>
                      <input
                        type="number"
                        name="price"
                        placeholder="Enter Price"
                        className="form-control"
                        id="price"
                        value={data.price}
                        onChange={formHandler}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      type="submit"
                      value={editingItemId ? "Update Item" : "Add Item"}
                      className="btn btn-sm text-white"
                      style={{ backgroundColor: "#085f9a" }}
                    />
                  </div>
                </form>
              </div>
              <div className="card-footer bg-white">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceItem?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.description}</td>
                          <td>&#8377; {item.price}</td>
                          <td>
                            <MdEdit
                              size={24}
                              style={{ color: "#085f9a" }}
                              onClick={() => startEditing(item)}
                            />
                          </td>
                          <td>
                            <MdDelete
                              size={24}
                              style={{ color: "red" }}
                              onClick={() => deleteItem(item.id)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceItem;